import React from 'react';
import { Control, Controller, FieldError, FieldValues, Path, RegisterOptions } from 'react-hook-form';

export interface FormElementProps {
	id?: string;
	value?: any;
	onChange?: (value: any) => void;
	onBlur?: () => void;
	error?: FieldError;
};

interface InputControllerProps<T extends FieldValues = FieldValues> {
	id: Path<T>;
	control: Control<T>;
	rules?: RegisterOptions<T, Path<T>>;
	children: React.ReactElement<any>;
}

export function InputController<T extends FieldValues>({ id, control, children, rules }: InputControllerProps<T>) {
	const { id: _, ...rest } = children.props;

	return (
		<Controller
			name={id}
			control={control}
			rules={rules}
			render={({ field, fieldState }) => {
				return React.createElement(children.type, {
					...rest,
					id,
					value: field.value,
					onChange: field.onChange,
					onBlur: field.onBlur,
					error: fieldState.error,
				});
			}}
		/>
	);
}
